import { ReactNode } from "react";
import { cn } from "~/lib/utils";

interface SectionNavGroupLabelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Labels a group of links within a section sidebar — the project rail's
 * "Sessions" block, the profile sidebar's "AI Settings" block.
 */
export const SectionNavGroupLabel = ({ children, className }: SectionNavGroupLabelProps) => (
  <p
    className={cn(
      "py-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground",
      className
    )}
  >
    {children}
  </p>
);
